import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';

import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';

import { SickIdAuthService } from '../sick-id-auth-service/sick-id-auth.service';

@Injectable({
  providedIn: 'root',
})
export class SickIdAuthGuard implements CanActivate {
  constructor(private authService: SickIdAuthService, private oidcService: OidcSecurityService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const authorized = this.authService.isLoggedIn().getValue();

    if (authorized) {
      return true;
    } else {
      localStorage.setItem('savedRoute', state.url);
      this.oidcService.authorize();
      return false;
    }
  }
}
